export default "__VITE_ASSET__BwAgTY1C__"